import { Flex, Loader } from "@ir/ui";

const LoadingSpinner = () => {
  return (
    <output className="loading-spinner">
      <Flex
        style={{
          width: "100%",
          height: "100%",
          position: "fixed",
          top: 0,
          left: 0,
        }}
        align="center"
        justifyContent="center"
      >
        <Loader loading />
      </Flex>
    </output>
  );
};

export default LoadingSpinner;
